export default __webpack_public_path__ + "static/media/customerLocation.e78b85a4.svg";